import { jsx as l } from "react/jsx-runtime";
import { u as $ } from "./index-6a632112.mjs";
import { c as b, C as w } from "./createOptions-4792754a.mjs";
import { s as t } from "./themes-5f0b3c3d.mjs";
import { f as y } from "./fontWeights-a25f8f91.mjs";
import { l as v } from "./lineHeights-72d3110c.mjs";
import "react";
const j = $.div`
  height: 100%;
  width: 100%;
  overflow-x: auto;

  .apexcharts-yaxistooltip {
    padding: 0 !important;
  }
  .apexcharts-legend.apx-legend-position-top,
  .apexcharts-legend.apx-legend-position-bottom {
    max-height: 100px !important;
  }
  .apexcharts-legend .apexcharts-legend-series {
    display: flex !important;
    align-items: center !important;
    padding: ${t["1x"]};
    gap: 10px;

    .apexcharts-legend-text {
      padding-left: unset;
      margin-left: unset;
    }
  }

  ${({ $vertical: e }) => {
  if (e)
    return `
      .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series {
        display: inline-flex;
        align-items: flex-start;
        padding: ${t["1x"]};
        padding-left: ${t["2x"]};
        margin: 0 !important;
        width: 100%;
      }
      .legend-item {
        width: 100%;
      }
      .apexcharts-legend-text {
        pointer-events: none;
        display: flex !important;
        /* gap: 10px; */
        justify-content: space-between !important;
      }
      .apexcharts-legend-text {
        width: 100% !important;
        line-height: ${v.small};
      }

      .total-label {
        position: absolute;
        font-weight: ${y.body.semibold};
        left: 0px;
        margin: 0px !important;
        padding-top: ${t["2x"]};
        width: 100%;
      }
      .total-text {
        margin-left: 0px !important;
      }
    `;
}}
`, T = ({
  chartLibElement: e,
  legend: i,
  isCategorical: d = !0,
  colorPallete: x = ["blue"],
  hideLabel: g = !1,
  labelFormatter: m,
  series: n,
  xAxis: h,
  yAxis: c,
  variant: p = "default",
  gridType: f = "xaxis",
  height: r = 350,
  width: o
}) => {
  const u = "light", a = b({
    legend: i,
    isCategorical: d,
    colorPallete: x,
    hideLabel: g,
    labelFormatter: m,
    xAxis: h,
    yAxis: c,
    type: w.BAR,
    variant: p,
    gridType: f,
    series: n,
    mode: u
  }), s = n;
  return a.grid = {
    ...a.grid,
    padding: {
      right: 50
    }
  }, /* @__PURE__ */ l(j, { $vertical: i?.orientation === "vertical", children: /* @__PURE__ */ l(
    e,
    {
      width: o ? `${o}px` : "100%",
      height: r ? `${r}px` : "350px",
      options: a,
      series: s,
      type: "bar"
    },
    `${p}_${s.length}`
  ) });
};
export {
  T as BarChart
};
